/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface UniteActiviteSearch
 */
export interface UniteActiviteSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof UniteActiviteSearch
     */
    anneeAcademique?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof UniteActiviteSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof UniteActiviteSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof UniteActiviteSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UniteActiviteSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof UniteActiviteSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof UniteActiviteSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the UniteActiviteSearch interface.
 */
export function instanceOfUniteActiviteSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UniteActiviteSearchFromJSON(json: any): UniteActiviteSearch {
    return UniteActiviteSearchFromJSONTyped(json, false);
}

export function UniteActiviteSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): UniteActiviteSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'anneeAcademique': !exists(json, 'anneeAcademique') ? undefined : TextSearchFromJSON(json['anneeAcademique']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function UniteActiviteSearchToJSON(value?: UniteActiviteSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'anneeAcademique': TextSearchToJSON(value.anneeAcademique),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

